
class CircleReel extends ReelsetComponent.src.CircleReel{
    public rows = 1;
    public countExtraSymbols = 1;
    public symbolHeight = 340;
    public typeEvent: string = '';
    protected defaultSpeed: number = 4;

    config: any = {
        speed: this.defaultSpeed,
        speedNormal: this.defaultSpeed,
        speedAnticipation: 3,
        startTween: {
            "time": 0
        },
        stopTween: {
            "deltaY": 65,
            "time": 50,
            "timeBack": 150
        }
    };

    protected stopTweenFinalReelIntrigue = {
        tween: 'cubicOut',
        tweenBack: 'cubicOut',
        deltaY: 230,
        time: 1000,
        timeBack: 300
    }

    protected stopTweenFinalReelReset = {
        tween: 'quintin',
        tweenBack: 'quintin',
        deltaY: 0,
        time: 0,
        timeBack: 0
    }

    protected stopTweenDefault = {
        "deltaY": 65,
        "time": 50,
        "timeBack": 150
    }

    init() {
        this.typeEvent = this.index === 0 ? 'REELSET_STOP_ALL' : 'REELSET_STOP';
        this.strip = new ReelsetComponent.src.Strip([10, 11, 12, 13, 14, 15, 16, 17, 18, 19]);
        this.view = game.tree.findByName(`numbers_reel_${this.index}`, game.tree.findAll(this.view));
        super.init();

        game.tree.findByName('numb_reel.container').addChild(this.view);
    }

    async randomStopFinalReel(randomValue: boolean){
        if(randomValue){
            this.playSpeedAnimation( 1300, 0.5)
            this.config.stopTween = this.stopTweenFinalReelIntrigue;
        } else {
            this.config.stopTween = this.stopTweenFinalReelReset;
            await game.utils.delay(450);
            await this.playSpeedAnimation(700, 0.1);
            await game.utils.delay(350);
            await this.playSpeedAnimation( 150, 2);
        }
    }

    async playSpeedAnimation(time: number, speedTo: number){
        const deltaSpeed: number = speedTo - this.config.speed;
        for(let i = 0; i < 10; i++){
            this.config.speed += deltaSpeed / 10
            await game.utils.delay(time/10)
        }
    }

    setDefaultOption(): void{
        this.config.stopTween = this.stopTweenDefault;
        this.config.speed = this.defaultSpeed;
    }

    override stoppingTween(cb) {
        const finish = game.utils.callLast(() => {
            if(this.index === 0)  game.emit(`BonusGameComponent.${this.typeEvent}`);
            cb();
        }, this.symbols.length);

        this.symbols.forEach((symbol, index) => {
            const stopPositionY = this.getSymbolPosition(index - this.countExtraSymbols);

            createjs.Tween.get(symbol.position)
                .to({y: stopPositionY + this.config.stopTween.deltaY}, this.config.stopTween.time, createjs.Ease[this.config.stopTween.tween || 'linear'])
                .to({y: stopPositionY}, this.config.stopTween.timeBack, createjs.Ease[this.config.stopTween.tweenBack || 'linear'])
                .call(finish);
        })
        if(this.index !== 0) {
            if (this.index === 2) {
                game.emit(`Intrigue.REEL_START`);
                game.emit('BonusReelsetComponent.REEL_BONUS_ANTICIPATION_STARTED');
            }
            game.emit(`BonusGameComponent.${this.typeEvent}`);
        }
    }
}

export {CircleReel}
